import React from 'react';

function HowItWorks() {
  return (
    <div>
      <div className="header user-header">
        <div className="container">
          <h1>How It Works</h1>
        </div>
      </div>

      <div className="container">
        <div className="content-page">
          <section>
            <h2>Using Coupon Adda is Simple!</h2>
            <p>Follow these easy steps to start saving money on your favorite brands:</p>
          </section>

          <div className="steps-container">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Browse Coupons</h3>
              <p>
                Explore our collection of verified coupons. Use the search bar to find specific brands
                or filter by payment app (GPay, Paytm, PhonePe) and category (Food, Fashion, Electronics, etc.).
              </p>
            </div>

            <div className="step">
              <div className="step-number">2</div>
              <h3>Find Your Deal</h3>
              <p>
                Click on any coupon to view details including discount amount, minimum order value,
                how to avail, and terms & conditions. Check the expiry date to ensure the coupon is still valid.
              </p>
            </div>

            <div className="step">
              <div className="step-number">3</div>
              <h3>Copy the Code</h3>
              <p>
                Click on the coupon code box to automatically copy it to your clipboard. You'll see a
                confirmation message that the code has been copied.
              </p>
            </div>

            <div className="step">
              <div className="step-number">4</div>
              <h3>Get the Deal</h3>
              <p>
                Click the "Get Deal" button to be redirected to the merchant's website or app.
                Paste the copied code at checkout and enjoy your discount!
              </p>
            </div>
          </div>

          <section>
            <h2>Tips for Maximum Savings</h2>
            <ul>
              <li><strong>Check Regularly:</strong> New deals are added daily</li>
              <li><strong>Read Terms:</strong> Always check minimum order value and T&C before using</li>
              <li><strong>Combine Offers:</strong> Some merchants allow stacking multiple discounts</li>
              <li><strong>Act Fast:</strong> Limited-time offers expire quickly</li>
              <li><strong>Bookmark Favorites:</strong> Save deals you plan to use later</li>
            </ul>
          </section>

          <section>
            <h2>Types of Coupons</h2>
            <div className="coupon-types">
              <div className="type-card">
                <h4>Percentage Off</h4>
                <p>Get a percentage discount on your order (e.g., 20% off)</p>
              </div>
              <div className="type-card">
                <h4>Flat Discount</h4>
                <p>Save a fixed amount on your purchase (e.g., ₹100 off)</p>
              </div>
              <div className="type-card">
                <h4>Cashback</h4>
                <p>Receive money back to your wallet after purchase</p>
              </div>
              <div className="type-card">
                <h4>Free Delivery</h4>
                <p>Waive delivery charges on your order</p>
              </div>
            </div>
          </section>

          <section>
            <h2>Frequently Asked Questions</h2>
            <div className="faq">
              <div className="faq-item">
                <h4>Are all coupons verified?</h4>
                <p>Yes, we verify all coupons before publishing. However, merchant terms may change, so always check validity before use.</p>
              </div>
              <div className="faq-item">
                <h4>Why didn't my coupon work?</h4>
                <p>Coupons may have expired, minimum order requirements, or specific product restrictions. Check the terms & conditions.</p>
              </div>
              <div className="faq-item">
                <h4>Can I use multiple coupons?</h4>
                <p>This depends on the merchant's policy. Most allow only one coupon per order.</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default HowItWorks;
